import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAppointment } from "../../Redux/actions/patientActions/appointmentActions.js";
import { listDepartments } from "../../Redux/actions/adminActions/departmentActions.js";
import { showToast } from "../../components/ToastMessage.jsx";
import { useSanitizedInput } from "../../hooks/useSanitizedInput.js";
import Loading from "../../components/Loading.jsx";
import SuccessPopup from "../../components/SuccessPopup.jsx";
import "../../App.css";

const AppointmentScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // ✅ Correct destructuring: [value, handleChange, reset, setValueDirect]
  const [mrCode, , , setMrCode] = useSanitizedInput("", "mrcode");
  const [pName, handlePNameChange, , setPName] = useSanitizedInput("", "alphanumeric");
  const [fatherName, handleFatherNameChange, resetFatherName] = useSanitizedInput("", "alphanumeric");
  const [age, handleAgeChange, resetAge] = useSanitizedInput("", "text");
  const [address, handleAddressChange, resetAddress] = useSanitizedInput("", "alphanumeric");
  const [contact, handleContactChange, resetContact] = useSanitizedInput("", "phone");
  const [department, setDepartment] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const { departments, loading, error } = useSelector((state) => state.departments);

  useEffect(() => {
    if (userInfo?.user) {
      // ✅ Use setValueDirect (4th element) for programmatic updates
      setPName(userInfo.user.name || "");
      setMrCode(userInfo.user.mrCode || "");
    }
    dispatch(listDepartments());
  }, [userInfo, dispatch, setPName, setMrCode]);

  const submitHandler = (e) => {
    e.preventDefault();
    
    // ✅ Validate
    if (!department) {
      showToast("Please select a department", "error");
      return;
    }
    
    if (pName.length < 2 || pName.length > 100) {
      showToast("Name must be 2-100 characters", "error");
      return;
    }
    
    if (contact && (contact.length < 10 || contact.length > 15)) {
      showToast("Please enter a valid phone number", "error");
      return;
    }
    
    dispatch(
      createAppointment({
        mrCode,
        pName,
        fatherName,
        age,
        address,
        contact,
        department,
      })
    );
    
    showToast("Appointment booked successfully!");
    setShowPopup(true);
    
    // Reset form
    setPName(userInfo?.user?.name || "");
    resetFatherName();
    resetAge();
    resetAddress();
    resetContact();
    setDepartment("");
  };

  return (
    <>
      {showPopup && (
        <SuccessPopup
          message="Your appointment has been booked successfully!"
          onClose={() => setShowPopup(false)}
        />
      )}
      <div className="appointment-page">
        <div className="appointmentbook-card">
          <p className="appointment-title text-center mb-4">{mrCode}</p>

          {loading && <Loading />}
          {error && <p className="text-danger">{error}</p>}

          <form onSubmit={submitHandler}>
            <div className="form-group mb-3">
              <label>Patient Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={pName}
                onChange={handlePNameChange} // ✅ Use handleChange for events
                maxLength="100"
                required
              />
            </div>
            
            <div className="form-group mb-3">
              <label>Father / Husband Name</label>
              <input
                type="text"
                className="form-control"
                value={fatherName}
                onChange={handleFatherNameChange}
                maxLength="100"
              />
            </div>
            
            <div className="form-group mb-3">
              <label>Age (Years / Months / Days)</label>
              <input
                type="text"
                className="form-control"
                value={age}
                onChange={handleAgeChange}
                maxLength="50"
              />
            </div>
            
            <div className="form-group mb-3">
              <label>Address</label>
              <input
                type="text"
                className="form-control"
                value={address}
                onChange={handleAddressChange}
                maxLength="200"
              />
            </div>
            
            <div className="form-group mb-3">
              <label>Contact / Whatsapp</label>
              <input
                type="tel"
                className="form-control"
                value={contact}
                onChange={handleContactChange}
                maxLength="15"
                pattern="[0-9+]*"
              />
            </div>
            
            <div className="form-group mb-4">
              <label>Department <span className="text-danger">*</span></label>
              <select
                className="form-select"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                required
              >
                <option value="">Select Department</option>
                {departments &&
                  departments.map((dept) => (
                    <option key={dept._id} value={dept.name}>
                      {dept.name}
                    </option>
                  ))}
              </select>
            </div>
            
            <button type="submit" className="btn btn-primary w-100">
              Book Appointment
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AppointmentScreen;